/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Insert_Button_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Insert Event" |
*
* @param {Event_Insert_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_insert_button_aria_label = /** @type {((inputs?: Event_Insert_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Insert_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer un evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントを挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir evento")
	return /** @type {LocalizedString} */ ("Insert Event")
});